import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { RESOURCES, LANGUAGES } from "./resources";

const supported = LANGUAGES.map((l) => l.code);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: RESOURCES,
    fallbackLng: "en",
    supportedLngs: supported,
    load: "languageOnly",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "ragi-lang",
      caches: ["localStorage"],
    },
  });

// Keep <html lang> and dir attributes in sync
function applyHtmlAttrs(lng) {
  if (typeof document === "undefined") return;
  const meta = LANGUAGES.find((l) => l.code === lng);
  document.documentElement.setAttribute("lang", lng || "en");
  document.documentElement.setAttribute("dir", meta && meta.rtl ? "rtl" : "ltr");
}

applyHtmlAttrs(i18n.language);
i18n.on("languageChanged", applyHtmlAttrs);

export default i18n;
